
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.67 12.5H.294l3.092-8.593h1.498L7.976 12.5H6.6L4.17 5.468h-.066L1.67 12.5zm.23-3.365h4.465v1.09H1.901v-1.09zM9.1 12.5v-.94l2.907-3.013c.31-.327.567-.614.768-.86.204-.249.357-.485.457-.709.101-.224.152-.461.152-.713 0-.286-.068-.532-.202-.739a1.317 1.317 0 00-.55-.482 1.748 1.748 0 00-.784-.172c-.308 0-.576.063-.806.189-.23.125-.405.303-.528.532a1.68 1.68 0 00-.185.806H9.091c0-.523.12-.98.361-1.372.24-.392.57-.695.99-.91.42-.219.897-.328 1.431-.328.54 0 1.016.108 1.427.323.414.213.737.504.969.873.232.366.348.78.348 1.242 0 .319-.06.63-.18.936-.118.305-.323.644-.617 1.02a17.4 17.4 0 01-1.225 1.355l-1.708 1.787v.063h3.869V12.5H9.1z","fill":"#748190"}})])
          )
        }
      }
    